import { UserRole } from '../../user/user-role';
import { EntityInstance } from '../common/entity-instance';
import { HubSettings } from './hub-settings';

export class Hub extends EntityInstance {
  public tenantId: string;
  public slug: string;
  public campusSlug: string;
  public role: UserRole;
  public hasCaremonitor: boolean;
  public hasCourse: boolean;
  public hasNewCase: boolean;
  public settings?: HubSettings[];
}
